import React from 'react'

import Circle from '../../public/svgs/circle.svg'

import { CalendarLessonStatus } from '../../types/trialLessons'
export const Status = ({ status }: { status: CalendarLessonStatus }) => {
  switch (status) {
    case 'reservable':
      return <img src={Circle.src} />
    case 'none':
      return <span className="text-text-gray-3">-</span>
    case 'full':
      return <span className="text-text-gray-3 text-xs">満席</span>
    case 'reserved':
      return <span className="text-text-gray-3 text-xs">予約済</span>
  }
}
